module.exports = __webpack_public_path__ + "static/media/7-4.57dc33d5.mp3";